import { render } from "./EditContractProposalPage.vue?vue&type=template&id=7f9dd382"
import script from "./EditContractProposalPage.vue?vue&type=script&lang=js"
export * from "./EditContractProposalPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__